import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';
import {
  CART_PAGE_NAME,
  CART_PAGE_SECTION,
  CART_PAGE_STAGE,
} from '../constants/cartui';
/**
 * Component that allows us to leverage translation files for page metadata.
 * Must be used within a LocalizationProvider component.
 */
export const PageMetadata = ({ language }) => {
  const [pageMetadata] = useTranslations(['pageMetadata']);
  return (
    <Helmet>
      <html lang={language} />
      <title>{pageMetadata.pageTitle}</title>
      <meta name="description" content={pageMetadata.pageDescription} />
      <meta name="robots" content="noindex" />
      <meta name="pageName" content={CART_PAGE_NAME} />
      <meta name="pageSection" content={CART_PAGE_SECTION} />
      <meta name="pageStage" content={CART_PAGE_STAGE} />
    </Helmet>
  );
};

PageMetadata.propTypes = {
  language: PropTypes.string.isRequired,
};
